import React from 'react';
import Backoffice from './components/Backoffice';

// Map to the richer Backoffice landing page component
const App = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Backoffice userId={'temp_admin'} />
    </div>
  );
};

export default App;
